import React from 'react';
import './Reviews.css';
import { useNavigate } from 'react-router-dom';

const reviews = [
  {
    name: "Sarah M.",
    role: "E-commerce Business Owner",
    avatar: "👩",
    review: "Matt made the entire process seamless. The app works flawlessly and we saw a revenue jump within the first month. Couldn't recommend him more.",
  },
  {
    name: "Jason L.",
    role: "Service Business, Niagara",
    avatar: "👨",
    review: "Our site went live fast and looked so clean. Clients immediately responded and bookings skyrocketed. Matt delivered exactly what he promised.",
  },
  {
    name: "Ravi P.",
    role: "Retail Store Owner",
    avatar: "🧑",
    review: "I can't believe how smooth everything was. Matt knows what he's doing, our web traffic and sales doubled after the new site launched.",
  },
  {
    name: "Emily R.",
    role: "Wellness Studio, Hamilton",
    avatar: "👩",
    review: "Working with Matt was a dream. Professional, creative, and the app he built brought us more clients than we ever imagined. True professional.",
  },
  {
    name: "Tyson W.",
    role: "Trades Business Owner",
    avatar: "👷",
    review: "Five stars isn't enough. Matt's work helped automate our business and bring in consistent income. Best investment we've made. Worth every penny.",
  },
];

const Reviews = () => {
  const navigate = useNavigate();

  return (
    <div className="reviews-container">

      {/* ── HEADER ── */}
      <div className="reviews-header">
        <span className="reviews-eyebrow">Client Reviews</span>
        <h1>Real Clients. <em>Real Results.</em></h1>
        <p>
          Don't take our word for it, here's what Ontario business owners say after working
          with DuDigital.
        </p>
      </div>

      {/* ── SCORE BAR ── */}
      <div className="reviews-score-bar">
        <div>
          <div className="score-num">5.0</div>
        </div>
        <div className="score-details">
          <div className="score-stars">★★★★★</div>
          <div className="score-label">Average rating across all clients</div>
        </div>
        <div className="score-divider" />
        <div className="score-stat">
          <div className="score-stat-num">120<span>+</span></div>
          <div className="score-stat-label">Projects Completed</div>
        </div>
        <div className="score-divider" />
        <div className="score-stat">
          <div className="score-stat-num">5<span>yr</span></div>
          <div className="score-stat-label">In Business</div>
        </div>
        <div className="score-divider" />
        <div className="score-stat">
          <div className="score-stat-num">30<span>k</span></div>
          <div className="score-stat-label">Organic App Downloads</div>
        </div>
      </div>

      {/* ── REVIEW CARDS ── */}
      <div className="reviews-grid">
        {reviews.map((r, i) => (
          <div key={i} className="review-card">
            <div className="review-stars">★★★★★</div>
            <p className="review-text">"{r.review}"</p>
            <div className="review-author">
              <div className="review-avatar">{r.avatar}</div>
              <div>
                <div className="review-name">{r.name}</div>
                <div className="review-role">{r.role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ── CTA ── */}
      <div className="reviews-cta">
        <h2>Ready to Be Our Next Success Story?</h2>
        <p>Book a free 15-minute call and let's talk about what we can build for you.</p>
        <a
          className="btn-bright"
          href="https://calendly.com/mattduarte56/15min"
          target="_blank"
          rel="noopener noreferrer"
        >
          Book My Free Call →
        </a>
      </div>

    </div>
  );
};

export default Reviews;